(function () {
  if (window.__scFlowerInlineUpsellInit) return;
  window.__scFlowerInlineUpsellInit = true;

  function normalizeCity(value) {
    var city = String(value || '').toLowerCase().trim();

    if (
      city.indexOf('jeddah') !== -1 ||
      city.indexOf('جدة') !== -1 ||
      city.indexOf('makkah') !== -1 ||
      city.indexOf('mecca') !== -1 ||
      city.indexOf('مكة') !== -1 ||
      city.indexOf('taif') !== -1 ||
      city.indexOf('الطائف') !== -1 ||
      city.indexOf('medina') !== -1 ||
      city.indexOf('madinah') !== -1 ||
      city.indexOf('المدينة') !== -1
    ) {
      return 'jeddah';
    }

    if (
      city.indexOf('riyadh') !== -1 ||
      city.indexOf('الرياض') !== -1 ||
      city.indexOf('kharj') !== -1 ||
      city.indexOf('الخرج') !== -1
    ) {
      return 'riyadh';
    }

    if (
      city.indexOf('dammam') !== -1 ||
      city.indexOf('الدمام') !== -1 ||
      city.indexOf('hasa') !== -1 ||
      city.indexOf('hassa') !== -1 ||
      city.indexOf('al hasa') !== -1 ||
      city.indexOf('al-hasa') !== -1 ||
      city.indexOf('الأحساء') !== -1 ||
      city.indexOf('الاحساء') !== -1 ||
      city.indexOf('jubail') !== -1 ||
      city.indexOf('الجبيل') !== -1
    ) {
      return 'dammam';
    }

    return '';
  }

  function getSelectedCity() {
    var candidates = [];

    if (window.scSelectedCity) candidates.push(window.scSelectedCity);
    if (window.scCurrentCity) candidates.push(window.scCurrentCity);
    if (window.selectedCity) candidates.push(window.selectedCity);
    if (window.currentCity) candidates.push(window.currentCity);

    try {
      [
        'sc_selected_city',
        'selected_city',
        'selectedCity',
        'scSelectedCity',
        'city',
        'customer_city',
        'delivery_city',
        'sc-city',
        'sc_city',
      ].forEach(function (key) {
        var value = window.localStorage && window.localStorage.getItem(key);
        if (value) candidates.push(value);
      });
    } catch (e) {}

    document
      .querySelectorAll(
        '[data-selected-city], [data-city-current], [data-current-city], [data-city-name], .sc-city-selector, .city-selector, .delivery-city, .city-name, [class*="city"], [class*="City"]'
      )
      .forEach(function (node) {
        var attr =
          node.getAttribute('data-selected-city') ||
          node.getAttribute('data-city-current') ||
          node.getAttribute('data-current-city') ||
          node.getAttribute('data-city-name');

        if (attr) candidates.push(attr);

        var text = (node.textContent || '').trim();
        if (text) candidates.push(text);
      });

    for (var i = 0; i < candidates.length; i += 1) {
      var normalized = normalizeCity(candidates[i]);
      if (normalized) return normalized;
    }

    return '';
  }

  function isTruthy(value) {
    return String(value || '').toLowerCase() === 'true';
  }

  function setButtonSoldOut(card, soldOut) {
    var addButton = card.querySelector('.sc-card-atc__plus');
    if (!addButton) return;

    card.classList.toggle('sc-card-atc--soldout', soldOut);
    card.classList.toggle('is-disabled', soldOut);

    addButton.disabled = soldOut;
    addButton.setAttribute('aria-disabled', soldOut ? 'true' : 'false');
    addButton.textContent = '+';
  }

  function updateCityVariantForCard(card) {
    if (!card || !card.matches('[data-sc-flower-inline-city-atc]')) return;

    var city = getSelectedCity();

    var variantId = '';
    var available = true;
    var min = card.getAttribute('data-min') || '1';
    var max = card.getAttribute('data-max') || '9999';

    if (city === 'jeddah' || city === 'riyadh' || city === 'dammam') {
      variantId = card.getAttribute('data-variant-' + city) || '';
      available = isTruthy(card.getAttribute('data-available-' + city));
      min = card.getAttribute('data-min-' + city) || min;
      max = card.getAttribute('data-max-' + city) || max;
    } else {
      variantId =
        card.getAttribute('data-fallback-variant-id') ||
        card.getAttribute('data-variant-id') ||
        '';
    }

    if (!variantId) {
      setButtonSoldOut(card, true);
      return;
    }

    card.setAttribute('data-variant-id', variantId);
    card.setAttribute('data-min', min || '1');
    card.setAttribute('data-max', max || '9999');

    var input = card.querySelector('[data-city-card-variant-input], input[name="id"]');
    if (input) input.value = variantId;

    var maxNumber = parseInt(max, 10);
    var shouldDisable = false;

    if (city === 'jeddah' || city === 'riyadh' || city === 'dammam') {
      shouldDisable = !available || (!Number.isNaN(maxNumber) && maxNumber <= 0);
    }

    setButtonSoldOut(card, shouldDisable);
  }

  function updateAllCityVariants(root) {
    (root || document)
      .querySelectorAll('[data-sc-flower-inline-city-atc]')
      .forEach(function (card) {
        updateCityVariantForCard(card);
      });
  }

  function unwrapOldRail(viewport) {
    var oldRail = viewport.querySelector(':scope > .sc-flower-inline-upsell__rail');

    if (!oldRail) return;

    Array.prototype.slice.call(oldRail.children).forEach(function (child) {
      if (child.getAttribute('data-sc-cloned-card') === 'true') return;
      viewport.appendChild(child);
    });

    oldRail.remove();
  }

  function unwrapOldMarquee(viewport) {
    var oldMarquee = viewport.querySelector(':scope > .sc-flower-inline-upsell__marquee');

    if (!oldMarquee) return;

    Array.prototype.slice.call(oldMarquee.children).forEach(function (child) {
      if (child.getAttribute('data-sc-cloned-card') === 'true') return;
      viewport.appendChild(child);
    });

    oldMarquee.remove();
  }

  function initFlowerSlider(viewport) {
    if (!viewport || viewport.dataset.scFlowerSliderInit === 'true') return;

    if (window.matchMedia && window.matchMedia('(min-width: 768px)').matches) return;

    viewport.dataset.scFlowerSliderInit = 'true';

/*
  Keep marquee movement LTR internally.
  Arabic text inside cards can still remain RTL through CSS.
*/
viewport.style.direction = 'ltr';

unwrapOldRail(viewport);
unwrapOldMarquee(viewport);

    var originalCards = Array.prototype.slice.call(viewport.children).filter(function (item) {
      return item.classList && item.classList.contains('sc-flower-inline-card');
    });

    if (!originalCards.length) return;

    var rail = document.createElement('div');
    rail.className = 'sc-flower-inline-upsell__rail';
    rail.style.direction = 'ltr';

    originalCards.forEach(function (card) {
      rail.appendChild(card);
    });

    viewport.appendChild(rail);

    var speed = parseFloat(viewport.getAttribute('data-speed')) || 24;
    var resumeDelay = parseInt(viewport.getAttribute('data-resume-delay'), 10) || 1500;

    var position = 0;
    var baseWidth = 0;
    var rafId = null;
    var lastTs = 0;

    var isDragging = false;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragStartPos = 0;
    var pauseUntil = 0;
    var isVisible = true;
    var hasStarted = false;
    var hasDragged = false;
    var suppressClick = false;

    function addCloneSet() {
      originalCards.forEach(function (card) {
        var clone = card.cloneNode(true);
        clone.setAttribute('data-sc-cloned-card', 'true');
        rail.appendChild(clone);
      });
    }

    function measure() {
  var items = rail.querySelectorAll('.sc-flower-inline-card:not([data-sc-cloned-card="true"])');
  if (!items.length) return;

  var total = 0;
  var styles = window.getComputedStyle(rail);
  var gap = parseFloat(styles.columnGap || styles.gap || 7);

  if (Number.isNaN(gap)) {
    gap = 7;
  }

  items.forEach(function (item) {
    total += item.offsetWidth;
  });

  /*
    Include the gap between the last original card and the first cloned card.
    Without this, the reset point is short and creates a visible jump in Arabic/RTL.
  */
  baseWidth = total + (items.length * gap);

  if (baseWidth <= 0) return;

  /*
    Make sure we have enough cloned content for a smooth loop.
    Original + enough clones to cover viewport.
  */
  while (rail.scrollWidth < baseWidth + viewport.clientWidth + 120) {
    addCloneSet();
  }
}

    function normalize() {
      if (!baseWidth) return;

      while (position <= -baseWidth) {
        position += baseWidth;
      }

      while (position > 0) {
        position -= baseWidth;
      }
    }

    function render() {
  rail.style.transform = 'translate3d(' + (Math.round(position * 100) / 100) + 'px,0,0)';
}

    function step(ts) {
      if (!lastTs) lastTs = ts;

      var dt = (ts - lastTs) / 1000;
      lastTs = ts;

      if (isVisible && !isDragging && Date.now() > pauseUntil && baseWidth > viewport.clientWidth) {
        position -= speed * dt;
        normalize();
        render();
      }

      rafId = window.requestAnimationFrame(step);
    }

    function pauseAuto() {
      pauseUntil = Date.now() + resumeDelay;
    }

    function pointerX(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientX;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientX;
      return e.clientX;
    }

    function pointerY(e) {
      if (e.touches && e.touches.length) return e.touches[0].clientY;
      if (e.changedTouches && e.changedTouches.length) return e.changedTouches[0].clientY;
      return e.clientY;
    }

    function onStart(e) {
      var target = e.target;

      /*
        Keep add-to-cart controls untouched.
        Allow dragging from image/title links, otherwise iOS has no usable drag area.
      */
      if (
        target.closest &&
        target.closest('button, input, select, textarea, .sc-card-atc, .sc-flower-inline-card__atc')
      ) {
        return;
      }

      isDragging = true;
      hasDragged = false;
      suppressClick = false;
      viewport.classList.add('is-dragging');

      dragStartX = pointerX(e);
      dragStartY = pointerY(e);
      dragStartPos = position;

      pauseAuto();
    }

    function onMove(e) {
      if (!isDragging) return;

      var x = pointerX(e);
      var y = pointerY(e);

      var deltaX = x - dragStartX;
      var deltaY = y - dragStartY;

      /*
        If customer is vertically scrolling page, release carousel.
      */
      if (!hasDragged && Math.abs(deltaY) > 12 && Math.abs(deltaY) > Math.abs(deltaX)) {
        onEnd();
        return;
      }

      if (Math.abs(deltaX) > 5) {
        hasDragged = true;
        suppressClick = true;
      }

      if (!hasDragged) return;

      position = dragStartPos + deltaX;
      normalize();
      render();

      if (e.cancelable) e.preventDefault();
    }

    function onEnd() {
      if (!isDragging) return;

      isDragging = false;
      viewport.classList.remove('is-dragging');
      pauseAuto();

      window.setTimeout(function () {
        hasDragged = false;
      }, 0);

      window.setTimeout(function () {
        suppressClick = false;
      }, 250);
    }

    /*
      Prevent product link opening after horizontal swipe.
    */
    viewport.addEventListener(
      'click',
      function (e) {
        if (!suppressClick) return;

        e.preventDefault();
        e.stopPropagation();

        suppressClick = false;
      },
      true
    );

    function start() {
      if (hasStarted) return;
      hasStarted = true;

      window.cancelAnimationFrame(rafId);

      lastTs = 0;
      measure();
      normalize();
      render();

      viewport.classList.add('is-ready');
      updateAllCityVariants(viewport);

      if (window.scMiniAtcSyncFromCart) {
        window.scMiniAtcSyncFromCart();
      }

      rafId = window.requestAnimationFrame(step);
    }

    function startWhenPageIsSettled() {
      var delay = 1200;

      if ('requestIdleCallback' in window) {
        window.setTimeout(function () {
          window.requestIdleCallback(start, { timeout: 2200 });
        }, 500);
      } else {
        window.setTimeout(start, delay);
      }
    }

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          isVisible = !!(entries[0] && entries[0].isIntersecting);
        },
        {
          root: null,
          threshold: 0,
        }
      );

      io.observe(viewport);
    }

    viewport.addEventListener('mousedown', onStart);
    viewport.addEventListener('touchstart', onStart, { passive: true });

    window.addEventListener('mousemove', onMove, { passive: false });
    window.addEventListener('touchmove', onMove, { passive: false });

    window.addEventListener('mouseup', onEnd);
    window.addEventListener('touchend', onEnd);
    window.addEventListener('touchcancel', onEnd);

    var resizeTimer = null;

    window.addEventListener('resize', function () {
      if (!hasStarted) return;

      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(function () {
        measure();
        normalize();
        render();
      }, 180);
    });

    startWhenPageIsSettled();
  }

  function init() {
    updateAllCityVariants(document);

    document.querySelectorAll('[data-sc-upsell-track]').forEach(initFlowerSlider);
  }

  document.addEventListener(
    'click',
    function (event) {
      var card = event.target.closest('[data-sc-flower-inline-city-atc]');
      if (card) {
        updateCityVariantForCard(card);
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    init();
  });

  window.addEventListener('storage', function () {
    updateAllCityVariants(document);
  });

  document.addEventListener('sc:city:changed', function () {
    updateAllCityVariants(document);
  });

  document.addEventListener('city:changed', function () {
    updateAllCityVariants(document);
  });
})();